<template>
    <router-view style="width: 100%; height: 100%;"></router-view>
</template>
<style lang="less" scoped>

</style>
<script>
    export default {
        data () {
            return {

            };
        },
        computed: {

        },
        watch:{

        },
        created(){

        },
        mounted(){

        },
        methods: {

        }
    };
</script>
